import { css } from 'styled-components';

/**
 * Number of pixels that is the maximum width to be still considered mobile.
 * One pixel more, and we are in desktop.
 */
export const MOBILE_BREAKPOINT = 768;
export const MAX_WIDTH_BREAKPOINT = `(max-width: ${MOBILE_BREAKPOINT}px)`;
export const MIN_WIDTH_BREAKPOINT = `(min-width: ${MOBILE_BREAKPOINT + 1}px)`;
export const MIN_WIDTH_TABLET_BREAKPOINT = `(min-width: ${
  MOBILE_BREAKPOINT + 1
}px)`;

export const TABLET_BREAKPOINT = 1024;
export const MAX_WIDTH_TABLET_BREAKPOINT = `(max-width: ${TABLET_BREAKPOINT}px)`;

/**
 * Center a div vertically.
 */
export const centerVertical = css`
  position: relative;
  top: 50%;
  transform: translateY(-50%);
`;

/**
 * Center a div horizontally.
 */
export const centerHorizontal = css`
  position: relative;
  margin: 0 auto;
`;

export const disableSelect = css`
  user-select: none;
  outline: none;
  -webkit-tap-highlight-color: transparent;
`;

const hideMobile = css`
  @media ${MAX_WIDTH_BREAKPOINT} {
    display: none !important;
  }
`;

const hideMobileAndTablet = css`
  @media ${MAX_WIDTH_TABLET_BREAKPOINT} {
    display: none !important;
  }
`;

const hideDesktopAndTablet = css`
  @media ${MIN_WIDTH_TABLET_BREAKPOINT} {
    display: none !important;
  }
`;

/**
 * Various media queries for triggering styles.
 */
export const mediaQueries = {
  /**
   * Styles applied on mobile layout
   */
  mobile: (...args) => css`
    @media only screen and ${MAX_WIDTH_BREAKPOINT} {
      ${css(...args)}
    }
  `,
  /**
   * Styles applied on desktop layout
   */
  desktop: (...args) => css`
    @media only screen and ${MIN_WIDTH_BREAKPOINT} {
      ${css(...args)}
    }
  `,
  mobileOnly: css`
    ${hideDesktopAndTablet};
  `,
  desktopOnly: css`
    ${hideMobileAndTablet};
  `,
  desktopAndTabletOnly: css`
    ${hideMobile};
  `,
};

export const getFontSizeCalc = ({
  min,
  max,
  coefficient = 1,
}: {
  min: number;
  max: number;
  coefficient?: number;
}) =>
  `calc((${min}px + ${max - min} * ((100vw - ${MOBILE_BREAKPOINT}px) / ${
    1600 - MOBILE_BREAKPOINT
  })) * ${coefficient})`;

export const generateFontSizeCss = (min, max) => css`
  font-size: ${min}px;
  ${mediaQueries.desktop`
    font-size: ${getFontSizeCalc({ min, max })};
  `}
`;

export const generateFontSizeCssForMapping = (mapping: {
  min: number;
  max: number;
}) => generateFontSizeCss(mapping.min, mapping.max);
